import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import FilterBy from '../../../components/PageHelpers/FilterBy'
import { filterImportUsersRolesDetailsList } from '../../../redux/features/importUsersRolesDetails/importUsersRolesDetailsThunk'
import { selectImportUsersRolesDetails } from '../../../redux/features/importUsersRolesDetails/importUsersRolesDetailsSlice'

const Desktop = () => {
  const importUsersRolesDetails = useSelector(selectImportUsersRolesDetails)

  return (

    <Box sx={styles.sortAndFilters}>
      <FilterBy
      store={importUsersRolesDetails}
        actionToDispatch={filterImportUsersRolesDetailsList}
        customStyle={styles.filter}
      />
        </Box>

  )
}
const styles = {
  sortAndFilters: {
    display: { xs: 'none', sm: 'flex' },
    justifyContent: 'end',
    my: '10px',
  },
  filter: {
    marginRight: '0px',
  },
}
export default Desktop
